import { HttpResponse } from "../../api/request"
import { api } from "../../api"
import { Ref } from "@vue/composition-api"
import { BookingModel } from "@/app/models/booking.model"
import { useCallbacksTCS } from "../merchant-callbacks/callbacks-tcs.reactive"

export function useReserveBooking() {
  async function reserveBooking(
    booking: Ref<BookingModel>,
  ): Promise<HttpResponse<any>> {
    const response = await api.reserveBooking(booking.value.referenceId)
    const { callbacks } = useCallbacksTCS()

    if (response.wasSuccessful && response.data) {
      booking.value.state = response.data.state
      booking.value.reservedAt = new Date(response.data.reservedAt as any)
      booking.value.referenceId = response.data.referenceId

      // Call the corresponding callback to the TCS Frontend App (Via Webview JS Bridge)
      callbacks.success()
    } else {
      // TODO: Clarify with Christian if thats okay to call error in that case
      callbacks.error()
    }

    return response
  }

  return { reserveBooking }
}
